import medicalRecordAPI from '../services/medicalRecordAPI';
import api from '../services/apiBase';

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        medicalRecords: [],
        medicalRecord: {},
        saving: false,
        saveError: "",
        deleting: false,
        deleteError: "",
        totalMedicalRecords: 0,
        NumberOfFollowups:0,
        FollowupsOfCurrentUser:[]

    },

    getters: {
        loadInProgress(state) {
            return state.loading;
        },
        getMedicalRecords(state) {
            return state.medicalRecords;
        },
        getMedicalRecord(state) {
            return state.medicalRecord;
        },
        getTotalMedicalRecords(state) {
            return state.totalMedicalRecords;
        },
        getFollowupsOfCurrentUser(state) {
            return state.FollowupsOfCurrentUser;
        },
        getNumberOfFollowups(state) {
            return state.NumberOfFollowups;
        }
    },

    mutations: {
        setMedicalRecords(state, data) {
            state.medicalRecords = data;
        },
        setMedicalRecord(state, data) {
            state.medicalRecord = data;
        },
        setTotalMedicalRecords(state, data) {
            state.totalMedicalRecords = data;
        },
        setNumberOfFollowups(state, data) {
            state.NumberOfFollowups = data;
        },
        setFollowupsOfCurrentUser(state, data) {
            state.FollowupsOfCurrentUser = data;
        },
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadComplete(state) {
            state.loading = false;
        },
        loadError(state, err) {
            state.specimens = [];
            state.loadError = err;
        },
        saving(state) {
            state.saving = true;
            state.saveError = "";
        },
        saveComplete(state) {
            state.saving = false;
        },
        saveError(state, err) {
            state.saveError = err;
        },
        clearSaveError(state) {
            state.saveError = "";
        },
    },

    actions: {
        clearSaveError(context) {
            context.commit("clearSaveError");
        },
        async saveMedicalRecord(context, data) {
            context.commit("saving");
            try {
                await medicalRecordAPI.saveMedicalRecord(data);
            } catch (e) {
                context.commit("saveError", api.parseHttpRequestError(e));
            } finally {
                context.commit("saveComplete");
            }
        },
        async getMedicalRecords(context, params) {
            context.commit("loading");
            try {
                const result = await medicalRecordAPI.getMedicalRecords(params)
                context.commit("setMedicalRecords", result.data.MedicalRecords);
                context.commit("setTotalMedicalRecords", result.data.TotalMedicalRecords)
            } catch (e) {
                context.commit("loadError", api.parseHttpRequestError(e));
            } finally {
                context.commit("loadComplete");
            }
        },
        async loadFollowupsOfCurrentUser(context, params) {
            try {
                const followups = await medicalRecordAPI.getFollowups(params);
                context.commit("setFollowupsOfCurrentUser", followups);
                context.commit("setNumberOfFollowups", followups.length);

            } catch (e) {
                this.loadError = e.message
            }
        },
    }
}